import { Button, ButtonGroup } from '@mui/material';
import React from 'react';
import { COLOR_PRIMARY_2, COLOR_PRIMARY_2_600 } from 'src/colors';
import { PAYMENT_MODAL_GREEN, PAYMENT_MODAL_GREEN_HOVER } from 'src/const';

const ToggleSwitch = ({
  values,
  type,
  setType,
  float,
  size,
  customStyle,
}: {
  values: string[];
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  float: string;
  size: 'small' | 'medium' | 'large';
  customStyle?: any;
}) => {
  const buttonStyle: any = {
    borderRadius: 1,
    border: 'none !important',
    textTransformation: 'none',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: COLOR_PRIMARY_2_600,
      color: '#FFF',
    },
  };
  return (
    <ButtonGroup
      variant="contained"
      size="small"
      sx={{ borderRadius: 2, background: '#fff', float, padding: '4px', ...customStyle }}
    >
      {values.map((data, i) => (
        <Button
          key={i}
          className={data == type ? 'subscriptionModalCountryBtn' : ''}
          size={size}
          onClick={() => {
            setType(data);
          }}
          sx={{
            ...buttonStyle,
            background: type === data ? COLOR_PRIMARY_2 : '#fff',
            color: type === data ? '#fff' : COLOR_PRIMARY_2,
          }}
        >
          {data}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ToggleSwitch;
